import { createApp } from "vue"
import VueDragscroll from "vue-dragscroll"
import ParkMap from "./ParkMap.vue"

const app = createApp(ParkMap)

app.use(VueDragscroll)
app.mount("#park-map-app")
